import React, { useEffect, useState, useMemo } from "react";
import { db, storage } from "../../firebaseConfig";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  deleteDoc,
  doc,
  updateDoc,
  limit,
  getDocs,
  where,
} from "firebase/firestore";
import { ref, deleteObject } from "firebase/storage";
import { toDateNumber, toDisplayDate, toIsoDate, toStorageDate } from "../../utils/date";
import ro from "/src/content/ro.json";

const AdminLatest = () => {
  const [latestProgram, setLatestProgram] = useState(null);
  const [latestPoza, setLatestPoza] = useState(null);
  const [latestTraseu, setLatestTraseu] = useState(null);
  const [latestRecenzie, setLatestRecenzie] = useState(null);
  const [latestAbonament, setLatestAbonament] = useState(null);

  const [drawerType, setDrawerType] = useState(null);
  const [drawerItems, setDrawerItems] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [abonamentFilter, setAbonamentFilter] = useState("TOATE");
  const [abonamentStatusFilter, setAbonamentStatusFilter] = useState("TOATE");
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [calendarSub, setCalendarSub] = useState(null);
  const [calendarStatus, setCalendarStatus] = useState({});
  const [calendarLoading, setCalendarLoading] = useState(false);
  const [calendarMonth, setCalendarMonth] = useState(() => {
    const now = new Date();
    return { year: now.getFullYear(), month: now.getMonth() };
  });
  const [editOpen, setEditOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [editDateFinal, setEditDateFinal] = useState("");
  const [editSaving, setEditSaving] = useState(false);

  useEffect(() => {
    const unsubAbonamente = onSnapshot(
      query(collection(db, "abonamente"), orderBy("createdAt", "desc"), limit(1)),
      (snapshot) => {
        const docSnap = snapshot.docs[0];
        setLatestAbonament(docSnap ? { id: docSnap.id, ...docSnap.data() } : null);
      }
    );

    const unsubProgram = onSnapshot(
      query(collection(db, "stabilire_program"), orderBy("createdAt", "desc"), limit(1)),
      (snapshot) => {
        const docSnap = snapshot.docs[0];
        setLatestProgram(docSnap ? { id: docSnap.id, ...docSnap.data() } : null);
      }
    );

    const unsubPoze = onSnapshot(
      query(collection(db, "poze_admin"), orderBy("uploadedAt", "desc"), limit(1)),
      (snapshot) => {
        const docSnap = snapshot.docs[0];
        setLatestPoza(docSnap ? { id: docSnap.id, ...docSnap.data() } : null);
      }
    );

    const unsubTraseu = onSnapshot(
      query(collection(db, "inscrieri_traseu"), orderBy("createdAt", "desc"), limit(1)),
      (snapshot) => {
        const docSnap = snapshot.docs[0];
        setLatestTraseu(docSnap ? { id: docSnap.id, ...docSnap.data() } : null);
      }
    );

    const unsubRecenzii = onSnapshot(
      query(collection(db, "recenzii"), orderBy("createdAt", "desc"), limit(1)),
      (snapshot) => {
        const docSnap = snapshot.docs[0];
        setLatestRecenzie(docSnap ? { id: docSnap.id, ...docSnap.data() } : null);
      }
    );

    return () => {
      unsubProgram();
      unsubPoze();
      unsubTraseu();
      unsubRecenzii();
      unsubAbonamente();
    };
  }, []);

  const handleDelete = async (type) => {
    try {
      let docRef;

      switch (type) {
        case "abonament":
          if (!latestAbonament) return alert("Niciun abonament de sters!");
          docRef = doc(db, "abonamente", latestAbonament.id);
          break;
        case "program":
          if (!latestProgram) return alert("Nimic de sters!");
          docRef = doc(db, "stabilire_program", latestProgram.id);
          break;
        case "poza":
          if (!latestPoza) return alert("Nicio poza de sters!");
          docRef = doc(db, "poze_admin", latestPoza.id);
          {
            let imagePath = latestPoza.path;
            if (!imagePath && latestPoza.url) {
              const url = latestPoza.url;
              const encodedPath = url.split("/o/")[1]?.split("?")[0];
              if (encodedPath) imagePath = decodeURIComponent(encodedPath);
            }
            if (imagePath) {
              const imageRef = ref(storage, imagePath);
              await deleteObject(imageRef);
            }
          }
          break;
        case "traseu":
          if (!latestTraseu) return alert("Nicio inscriere de sters!");
          docRef = doc(db, "inscrieri_traseu", latestTraseu.id);
          break;
        case "recenzie":
          if (!latestRecenzie) return alert("Nicio recenzie de sters!");
          docRef = doc(db, "recenzii", latestRecenzie.id);
          break;
        default:
          return;
      }

      if (docRef) {
        await deleteDoc(docRef);
        setPopupText(`OK: ${type} sters cu succes!`);
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
      }
    } catch (err) {
      console.error("Eroare la stergere:", err);
      setPopupText("Eroare la stergere!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    }
  };

  const openDrawer = async (type) => {
    try {
      let q;
      switch (type) {
        case "abonament":
          q = query(collection(db, "abonamente"), orderBy("createdAt", "desc"));
          break;
        case "program":
          q = query(collection(db, "stabilire_program"), orderBy("createdAt", "desc"));
          break;
        case "poza":
          q = query(collection(db, "poze_admin"), orderBy("uploadedAt", "desc"));
          break;
        case "traseu":
          q = query(collection(db, "inscrieri_traseu"), orderBy("createdAt", "desc"));
          break;
        case "recenzie":
          q = query(collection(db, "recenzii"), orderBy("createdAt", "desc"));
          break;
        default:
          return;
      }

      const snapshot = await getDocs(q);
      const data = snapshot.docs.map((docSnap) => ({ id: docSnap.id, ...docSnap.data() }));
      setDrawerType(type);
      setDrawerItems(data);
      if (type !== "abonament") {
        setAbonamentFilter("TOATE");
        setAbonamentStatusFilter("TOATE");
      }
    } catch (err) {
      console.error("Eroare la incarcare:", err);
    }
  };

  useEffect(() => {
    const handler = (event) => {
      const type = event?.detail?.type;
      if (!type) return;
      openDrawer(type);
    };
    window.addEventListener("adminOpenDrawer", handler);
    return () => window.removeEventListener("adminOpenDrawer", handler);
  }, []);

  const filteredDrawerItems = useMemo(() => {
    if (drawerType !== "abonament") return drawerItems;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const todayNum = today.getTime();

    const matchesStatus = (item) => {
      const end = toDateNumber(item.dataFinal || item.dataExpirare || "");
      const isExpired = Boolean(end) && todayNum > end;
      const isActive = !isExpired;

      if (abonamentStatusFilter === "ACTIVE") return isActive;
      if (abonamentStatusFilter === "EXPIRATE") return isExpired;
      return true;
    };

    return drawerItems.filter((item) => {
      const tip = (item.tipTraseu || "").toString().trim().toUpperCase();
      const matchesCategory = abonamentFilter === "TOATE" || tip === abonamentFilter;
      return matchesCategory && matchesStatus(item);
    });
  }, [drawerItems, drawerType, abonamentFilter, abonamentStatusFilter]);

  const openEditFinalDate = (item) => {
    if (!item) return;
    setEditItem(item);
    setEditDateFinal(toDisplayDate(item.dataFinal || item.dataExpirare || ""));
    setEditOpen(true);
  };

  const closeEditFinalDate = () => {
    setEditOpen(false);
    setEditItem(null);
    setEditDateFinal("");
    setEditSaving(false);
  };

  const handleUpdateFinalDate = async () => {
    if (!editItem) return;
    const normalized = toStorageDate(editDateFinal);
    if (!normalized) {
      alert("Data finala trebuie sa fie in format dd/mm/yyyy.");
      return;
    }
    const startNum = toDateNumber(editItem.dataInceput || "");
    const endNum = toDateNumber(normalized);
    if (startNum && endNum && endNum < startNum) {
      alert("Data finala nu poate fi inainte de data de inceput.");
      return;
    }

    try {
      setEditSaving(true);
      await updateDoc(doc(db, "abonamente", editItem.id), {
        dataFinal: normalized,
        dataExpirare: normalized,
        updatedAt: new Date().toISOString(),
      });

      setDrawerItems((prev) =>
        prev.map((it) =>
          it.id === editItem.id
            ? { ...it, dataFinal: normalized, dataExpirare: normalized }
            : it
        )
      );
      setLatestAbonament((prev) =>
        prev && prev.id === editItem.id
          ? { ...prev, dataFinal: normalized, dataExpirare: normalized }
          : prev
      );

      setPopupText("OK: data finala actualizata!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
      closeEditFinalDate();
    } catch (err) {
      console.error("Eroare la actualizare abonament:", err);
      setPopupText("Eroare la actualizare!");
      setShowPopup(true);
      setTimeout(() => setShowPopup(false), 3000);
    } finally {
      setEditSaving(false);
    }
  };

  const openSubscriptionCalendar = async (sub) => {
    if (!sub) return;
    setCalendarSub(sub);
    setCalendarStatus({});
    setCalendarOpen(true);
    setCalendarLoading(true);

    const startNum = toDateNumber(sub.dataInceput || "");
    const endNum = toDateNumber(sub.dataFinal || sub.dataExpirare || "");
    const baseDate = startNum ? new Date(startNum) : new Date();
    setCalendarMonth({ year: baseDate.getFullYear(), month: baseDate.getMonth() });

    const statusMap = {};
    const email = (sub.email || sub.userEmail || "").toLowerCase().trim();
    const userId = sub.userId || sub.uid || "";
    const tip = (sub.tipTraseu || "").toUpperCase();

    const collect = (snap) => {
      snap.forEach((docSnap) => {
        const data = docSnap.data() || {};
        const dateNum = toDateNumber(data.data || data.date || "");
        if (!dateNum) return;
        if (startNum && endNum && (dateNum < startNum || dateNum > endNum)) return;
        const iso = toIsoDate(data.data || data.date || "");
        if (!iso) return;
        if (!data.status) return;
        statusMap[iso] = data.status;
      });
    };

    try {
      if (email) {
        const qEmail = tip
          ? query(
              collection(db, "prezente"),
              where("userEmail", "==", email),
              where("tipProgram", "==", tip)
            )
          : query(collection(db, "prezente"), where("userEmail", "==", email));
        const snapEmail = await getDocs(qEmail);
        collect(snapEmail);
      }
      if (userId) {
        const qId = tip
          ? query(
              collection(db, "prezente"),
              where("userId", "==", userId),
              where("tipProgram", "==", tip)
            )
          : query(collection(db, "prezente"), where("userId", "==", userId));
        const snapId = await getDocs(qId);
        collect(snapId);
      }
    } catch (err) {
      console.error("Eroare la incarcare prezente abonament:", err);
    } finally {
      setCalendarStatus(statusMap);
      setCalendarLoading(false);
    }
  };

  const closeCalendar = () => {
    setCalendarOpen(false);
    setCalendarSub(null);
    setCalendarStatus({});
  };

  const changeMonth = (delta) => {
    const next = new Date(calendarMonth.year, calendarMonth.month + delta, 1);
    setCalendarMonth({ year: next.getFullYear(), month: next.getMonth() });
  };

  const calendarDays = useMemo(() => {
    if (!calendarSub) return [];
    const { year, month } = calendarMonth;
    const firstDay = new Date(year, month, 1);
    const startOffset = (firstDay.getDay() + 6) % 7;
    const totalDays = new Date(year, month + 1, 0).getDate();
    const startNum = toDateNumber(calendarSub.dataInceput || "");
    const endNum = toDateNumber(calendarSub.dataFinal || calendarSub.dataExpirare || "");
    const arr = [];
    for (let i = 0; i < startOffset; i++) arr.push(null);
    for (let d = 1; d <= totalDays; d++) {
      const iso = `${year}-${String(month + 1).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
      const dateNum = new Date(year, month, d).getTime();
      const inRange = startNum && endNum ? dateNum >= startNum && dateNum <= endNum : false;
      const status = calendarStatus[iso];
      arr.push({ day: d, iso, inRange, status });
    }
    return arr;
  }, [calendarMonth, calendarSub, calendarStatus]);

  return (
    <div className="admin-latest-card admin-actualizari admin-row2-card">
      <div className="admin-latest-list">
        {/* PROGRAM */}
        <div className="admin-latest-row">
          <div className="admin-latest-content">
            <p className="admin-latest-title">Ultimul program adaugat</p>
            {latestProgram ? (
              <p className="admin-latest-meta">
                {latestProgram.tipProgram} - {toDisplayDate(latestProgram.data)} - {latestProgram.ora}
              </p>
            ) : (
              <p className="admin-latest-meta text-neutral-500">Nicio inregistrare</p>
            )}
          </div>
          <div className="flex gap-2">
            <button className="admin-latest-view" onClick={() => openDrawer("program")}> 
              Vezi toate
            </button>
            <button className="admin-latest-delete" onClick={() => handleDelete("program")}> 
              Sterge
            </button>
          </div>
        </div>

        {/* ABONAMENT */}
        <div className="admin-latest-row">
          <div className="admin-latest-content">
            <p className="admin-latest-title">Ultimul abonament</p>
            {latestAbonament ? (
              <p className="admin-latest-meta">
                {latestAbonament.nume} - {toDisplayDate(latestAbonament.dataInceput)} {"\u2192"} {toDisplayDate(latestAbonament.dataFinal)}
              </p>
            ) : (
              <p className="admin-latest-meta text-neutral-500">Niciun abonament adaugat</p>
            )}
          </div>

          <div className="flex gap-2">
            <button className="admin-latest-view" onClick={() => openDrawer("abonament")}> 
              Vezi toate
            </button>
            <button className="admin-latest-delete" onClick={() => handleDelete("abonament")}> 
              Sterge
            </button>
          </div>
        </div>

        {/* POZE */}
        <div className="admin-latest-row">
          <div className="admin-latest-content">
            <p className="admin-latest-title">Ultima poza adaugata</p>
            {latestPoza ? (
              <p className="admin-latest-meta">{latestPoza.nume}</p>
            ) : (
              <p className="admin-latest-meta text-neutral-500">Nicio poza</p>
            )}
          </div>
          <div className="flex gap-2">
            <button className="admin-latest-view" onClick={() => openDrawer("poza")}> 
              Vezi toate
            </button>
            <button className="admin-latest-delete" onClick={() => handleDelete("poza")}> 
              Sterge
            </button>
          </div>
        </div>

        {/* TRASEU */}
        <div className="admin-latest-row">
          <div className="admin-latest-content">
            <p className="admin-latest-title">Ultima inscriere la traseu</p>
            {latestTraseu ? (
              <p className="admin-latest-meta">
                {latestTraseu.numePrenume ||
                  latestTraseu.nume ||
                  latestTraseu.userName ||
                  latestTraseu.name ||
                  "-"}{" "}
                - {latestTraseu.tipTraseu}
              </p>
            ) : (
              <p className="admin-latest-meta text-neutral-500">Nicio inscriere</p>
            )}
          </div>
          <div className="flex gap-2">
            <button className="admin-latest-view" onClick={() => openDrawer("traseu")}> 
              Vezi toate
            </button>
            <button className="admin-latest-delete" onClick={() => handleDelete("traseu")}> 
              Sterge
            </button>
          </div>
        </div>

        {/* RECENZII */}
        <div className="admin-latest-row">
          <div className="admin-latest-content">
            <p className="admin-latest-title">Ultima recenzie</p>
            {latestRecenzie ? (
              <p className="admin-latest-meta">{latestRecenzie.nume}</p>
            ) : (
              <p className="admin-latest-meta text-neutral-500">Nicio recenzie</p>
            )}
          </div>
          <div className="flex gap-2">
            <button className="admin-latest-view" onClick={() => openDrawer("recenzie")}> 
              Vezi toate
            </button>
            <button className="admin-latest-delete" onClick={() => handleDelete("recenzie")}> 
              Sterge
            </button>
          </div>
        </div>
      </div>

      {showPopup && (
        <div
          className={`admin-popup ${
            popupText.startsWith("Eroare") ? "bg-red-600" : "bg-green-600"
          }`}
        >
          {popupText}
        </div>
      )}

      {drawerType && (
        <div className="admin-drawer-overlay" onClick={() => setDrawerType(null)}>
          <div className="admin-drawer" onClick={(e) => e.stopPropagation()}>
            <h3 className="admin-drawer-title">LISTA {drawerType.toUpperCase()} - lista completa</h3>

            {drawerType === "abonament" && (
              <div className="mb-4 grid grid-cols-2 gap-3">
                <div>
                  <label className="text-sm font-semibold text-neutral-300">
                    Filtru categorie
                  </label>
                  <select
                    className="admin-select w-full mt-2"
                    value={abonamentFilter}
                    onChange={(e) => setAbonamentFilter(e.target.value)}
                  >
                    <option value="TOATE">Toate</option>
                    <option value="MAI">MAI</option>
                    <option value="MAPN">MAPN</option>
                    <option value="ISU">ISU</option>
                    <option value="ANP">ANP</option>
                  </select>
                </div>
                <div>
                  <label className="text-sm font-semibold text-neutral-300">
                    Filtru status
                  </label>
                  <select
                    className="admin-select w-full mt-2"
                    value={abonamentStatusFilter}
                    onChange={(e) => setAbonamentStatusFilter(e.target.value)}
                  >
                    <option value="TOATE">Toate</option>
                    <option value="ACTIVE">Active</option>
                    <option value="EXPIRATE">Expirate</option>
                  </select>
                </div>
              </div>
            )}

            <div className="admin-drawer-list">
              {filteredDrawerItems.length > 0 ? (
                filteredDrawerItems.map((item) => {
                  const endNum = toDateNumber(item.dataFinal || item.dataExpirare || "");
                  const now = new Date();
                  now.setHours(0, 0, 0, 0);
                  const daysLeft =
                    endNum != null
                      ? Math.ceil((endNum - now.getTime()) / 86400000)
                      : null;
                  const isExpiring = daysLeft != null && daysLeft <= 3 && daysLeft >= 0;

                  return (
                    <div
                      key={item.id}
                      className="admin-item-card bg-neutral-800 border border-neutral-700 rounded-xl p-4 shadow-md flex flex-col gap-3"
                    >
                      {/* PROGRAM */}
                      {drawerType === "program" && (
                        <>
                          <div className="flex items-center gap-2 mb-1 text-orange-400">
                            <p className="font-semibold">Program antrenament</p>
                          </div>
                          <div className="grid grid-cols-2 gap-y-1 text-sm text-neutral-100">
                            <p>
                              <span className="font-semibold text-orange-400">Tip:</span>{" "}
                              {item.tipProgram || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Data:</span>{" "}
                              {toDisplayDate(item.data) || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Ora:</span>{" "}
                              {item.ora || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Locatie:</span>{" "}
                              {item.locatie || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Cost:</span>{" "}
                              {item.cost || "-"}
                            </p>
                          </div>
                        </>
                      )}

                      {/* POZE */}
                      {drawerType === "poza" && (
                        <>
                          <div className="flex items-center gap-2 mb-1 text-orange-400">
                            <p className="font-semibold">Poza</p>
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            <img
                              src={item.url}
                              alt={item.nume}
                              className="w-64 h-64 object-cover rounded-xl border border-neutral-700 shadow-lg"
                            />
                            <p className="text-sm text-neutral-300">{item.nume}</p>
                          </div>
                        </>
                      )}

                      {/* TRASEU */}
                      {drawerType === "traseu" && (
                        <>
                          <div className="flex items-center gap-2 mb-1 text-orange-400">
                            <p className="font-semibold">Inscriere traseu</p>
                          </div>
                          <div className="grid grid-cols-2 md:grid-cols-3 gap-y-1 text-sm text-neutral-100">
                            <p>
                              <span className="font-semibold text-orange-400">Nume:</span>{" "}
                              {item.numePrenume ||
                                item.nume ||
                                item.userName ||
                                item.name ||
                                "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Email:</span>{" "}
                              {item.email || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Telefon:</span>{" "}
                              {item.telefon || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Varsta:</span>{" "}
                              {item.varsta || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Traseu:</span>{" "}
                              {item.tipTraseu || "-"}
                            </p>
                          </div>
                        </>
                      )}

                      {/* ABONAMENT */}
                      {drawerType === "abonament" && (
                        <>
                          <div className="flex items-center justify-between gap-2 mb-1 text-orange-400">
                            <p className="font-semibold">Abonament</p>
                            <button
                              type="button"
                              className={`attendance-pill attendance-alert ${
                                isExpiring ? "is-expiring" : "is-active"
                              }`}
                              aria-label="Status abonament"
                              title="Status abonament"
                              onClick={() => openSubscriptionCalendar(item)}
                            >
                              <span className="attendance-alert-icon">
                                {isExpiring ? "!" : "\u2605"}
                              </span>
                            </button>
                          </div>
                          <div className="grid grid-cols-2 md:grid-cols-3 gap-y-1 text-sm text-neutral-100">
                            <p>
                              <span className="font-semibold text-orange-400">Nume:</span>{" "}
                              {item.nume || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Email:</span>{" "}
                              {item.email || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Telefon:</span>{" "}
                              {item.telefon || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Categorie:</span>{" "}
                              {item.tipTraseu || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Plan:</span>{" "}
                              {item.planAlimentar || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Inceput:</span>{" "}
                              {toDisplayDate(item.dataInceput)}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Final:</span>{" "}
                              {toDisplayDate(item.dataFinal)}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Status:</span>{" "}
                              {(() => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const todayNum = today.getTime();
                                const start = toDateNumber(item.dataInceput || "");
                                const end = toDateNumber(item.dataFinal || item.dataExpirare || "");
                                const isExpired = Boolean(end) && todayNum > end;
                                if (isExpired) return "Expirat";
                                if (start && todayNum < start) return "In asteptare";
                                return "Activ";
                              })()}
                            </p>
                          </div>
                        </>
                      )}

                      {/* RECENZII */}
                      {drawerType === "recenzie" && (
                        <>
                          <div className="flex items-center gap-2 mb-1 text-orange-400">
                            <p className="font-semibold">Recenzie</p>
                          </div>
                          <div className="flex flex-col gap-1 text-sm text-neutral-100">
                            <p>
                              <span className="font-semibold text-orange-400">Nume:</span>{" "}
                              {item.nume || "-"}
                            </p>
                            <p>
                              <span className="font-semibold text-orange-400">Mesaj:</span>
                            </p>
                            <p className="italic text-neutral-300 bg-neutral-900/70 p-2 rounded-lg border border-neutral-700">
                              "{item.text || "-"}"
                            </p>
                          </div>
                        </>
                      )}

                      <div className="flex justify-center mt-3 gap-2">
                        {drawerType === "abonament" && (
                          <button
                            type="button"
                            className="admin-drawer-update"
                            onClick={() => openEditFinalDate(item)}
                          >
                            Update
                          </button>
                        )}
                        <button
                          onClick={async () => {
                            try {
                              await deleteDoc(
                                doc(
                                  db,
                                  drawerType === "poza"
                                    ? "poze_admin"
                                    : drawerType === "traseu"
                                    ? "inscrieri_traseu"
                                    : drawerType === "abonament"
                                    ? "abonamente"
                                    : drawerType === "recenzie"
                                    ? "recenzii"
                                    : "stabilire_program",
                                  item.id
                                )
                              );
                              setDrawerItems((prev) => prev.filter((x) => x.id !== item.id));
                              setPopupText(`OK: ${drawerType} sters cu succes!`);
                              setShowPopup(true);
                              setTimeout(() => setShowPopup(false), 3000);
                            } catch (err) {
                              console.error("Eroare la stergere:", err);
                              setPopupText(`Eroare la stergere ${drawerType}!`);
                              setShowPopup(true);
                              setTimeout(() => setShowPopup(false), 3000);
                            }
                          }}
                          className="admin-drawer-delete"
                        >
                          Sterge
                        </button>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p className="text-neutral-400 text-center">
                  Nicio inregistrare gasita.
                </p>
              )}
            </div>

            <button className="admin-drawer-close" onClick={() => setDrawerType(null)}>
              Inchide
            </button>

            {editOpen && editItem && (
              <div
                className="attendance-calendar-overlay"
                style={{ backgroundColor: "var(--drawer-overlay)" }}
                onClick={closeEditFinalDate}
              >
                <div
                  className="drawer-card drawer-modal attendance-calendar-modal w-full max-w-none max-h-full overflow-auto p-6 space-y-4"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="drawer-kicker" style={{ color: "var(--color-accent)" }}>
                        Actualizeaza data finala
                      </p>
                      <h3 className="text-xl font-bold">
                        {editItem.nume || editItem.userName || "Abonament"}
                      </h3>
                      <p className="drawer-muted mt-1">
                        {editItem.email || editItem.userEmail || "-"}
                      </p>
                    </div>
                    <button
                      className="drawer-close"
                      onClick={closeEditFinalDate}
                      aria-label="Inchide"
                    >
                      X
                    </button>
                  </div>

                  <label className="admin-label">Data finala</label>
                  <input
                    type="text"
                    className="admin-input"
                    placeholder="zz/ll/yyyy"
                    value={editDateFinal}
                    onChange={(e) => setEditDateFinal(e.target.value)}
                  />

                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      className="admin-drawer-cancel"
                      onClick={closeEditFinalDate}
                    >
                      Renunta
                    </button>
                    <button
                      type="button"
                      className="admin-drawer-update"
                      onClick={handleUpdateFinalDate}
                      disabled={editSaving}
                    >
                      {editSaving ? "Se salveaza..." : "Salveaza"}
                    </button>
                  </div>
                </div>
              </div>
            )}

            {calendarOpen && calendarSub && (
              <div
                className="attendance-calendar-overlay"
                style={{ backgroundColor: "var(--drawer-overlay)" }}
              >
                <div className="drawer-card drawer-modal attendance-calendar-modal w-full max-w-none max-h-full overflow-auto p-6 space-y-5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <p className="drawer-kicker" style={{ color: "var(--color-accent)" }}>
                        Calendar abonament
                      </p>
                      <h3 className="text-2xl font-bold">
                        {calendarSub.userName || calendarSub.nume || "Abonat"}
                      </h3>
                      <p className="drawer-muted mt-1">
                        {calendarSub.email || calendarSub.userEmail || "-"}
                      </p>
                      <p className="drawer-muted mt-1">
                        {toDisplayDate(calendarSub.dataInceput)} {"\u2013"}{" "}
                        {toDisplayDate(calendarSub.dataFinal || calendarSub.dataExpirare)}
                      </p>
                    </div>
                    <button
                      className="drawer-close"
                      onClick={closeCalendar}
                      aria-label="Inchide calendar"
                    >
                      X
                    </button>
                  </div>

                  <div className="flex items-center justify-between gap-3 flex-wrap">
                    <button
                      onClick={() => changeMonth(-1)}
                      className="drawer-close attendance-calendar-arrow"
                      aria-label="Luna anterioara"
                    >
                      {"<"}
                    </button>
                    <p className="text-lg font-semibold">
                      {(ro?.profile?.attendance?.months || [])[calendarMonth.month] || ""}
                      {calendarMonth.year ? ` ${calendarMonth.year}` : ""}
                    </p>
                    <button
                      onClick={() => changeMonth(1)}
                      className="drawer-close attendance-calendar-arrow"
                      aria-label="Luna urmatoare"
                    >
                      {">"}
                    </button>
                  </div>

                  {calendarLoading && <p className="drawer-muted">Se incarca...</p>}

                  <div className="grid grid-cols-7 gap-2 text-center text-sm">
                    {(ro?.profile?.attendance?.weekdays || []).map((wd) => (
                      <div
                        key={wd}
                        className="font-semibold"
                        style={{ color: "var(--color-secondary-text)" }}
                      >
                        {wd}
                      </div>
                    ))}
                    {calendarDays.map((cell, idx) => {
                      if (!cell) return <div key={`empty-${idx}`} />;
                      let background = "var(--drawer-card)";
                      let color = "var(--color-text)";
                      if (cell.status === "prezent") {
                        background = "var(--color-success-soft)";
                        color = "var(--color-success)";
                      } else if (cell.status === "absent") {
                        background = "var(--color-danger-soft)";
                        color = "var(--color-danger)";
                      } else if (cell.inRange) {
                        background = "rgba(249,115,22,0.15)";
                        color = "#f97316";
                      }
                      return (
                        <div
                          key={cell.iso}
                          className="rounded-lg font-semibold"
                          style={{
                            padding: "12px 0",
                            border: "1px solid var(--drawer-border)",
                            backgroundColor: background,
                            color,
                          }}
                        >
                          {cell.day}
                        </div>
                      );
                    })}
                  </div>

                  <button onClick={closeCalendar} className="drawer-cta secondary">
                    Inchide
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminLatest;
